module.exports = __webpack_public_path__ + "static/media/locked.8b9bb167.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/locked.svg
// module id = 1569
// module chunks = 0